import { render, staticRenderFns } from "./TipoIncapacidad.vue?vue&type=template&id=007876b3&scoped=true"
import script from "./TipoIncapacidad.vue?vue&type=script&lang=js"
export * from "./TipoIncapacidad.vue?vue&type=script&lang=js"
import style0 from "./TipoIncapacidad.vue?vue&type=style&index=0&id=007876b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007876b3",
  null
  
)

export default component.exports